import {
  TopBar as TopBarBase,
  ITopBarProps,
} from '@oliasoft-open-source/react-ui-library';
import { usePkce } from '@oliasoft/pkce';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import ClientConfig from 'client/config';
import { routes } from 'client/views/navigation/routes/routes';
import { useEffect } from 'react';
import { getUserInfo } from 'client/store/entities/user/user';
import { RootState } from 'client/store/configureStore';
import { ConnectedProps, connect } from 'react-redux';
import { getCustomerState } from 'client/store/entities/customer/selectors';
import Logo from './logo-atlas.svg';
import Logomark from './oliasoft-logomark.svg';
import { LanguagePicker } from './language-picker/language-picker';
import { UserMenu } from './user-menu/user-menu';

const TopBar = ({
  user,
  selectedCustomer,
  getUserInfo,
}: PropsFromRedux) => {
  useEffect(() => {
    getUserInfo();
  }, []);

  const navigate = useNavigate();
  const { companyId } = useParams();

  const auth = usePkce();
  const handleLogout = async () => {
    await auth.logout();
  };

  return (
    <TopBarBase
      appSwitcher={{
        icon: Logomark,
        url: ClientConfig.config.dashboardUrl,
      }}
      title={{
        logo: <img src={Logo} alt="Atlas" />,
        onClick: () => navigate(routes.root.pattern.path),
      }}
      contentRight={[
        {
          type: 'Component',
          component: <LanguagePicker />,
        },
        ...(auth?.accessToken
          ? [
            {
              component: (
                <UserMenu
                  navToUserProfile={() => navigate(generatePath(routes.userSettingsTabs.pattern.path, {
                    companyId, settingsPageId: 'general', settingsPageTabId: 'user_account',
                  }))}
                  navToCompanies={() => navigate(generatePath(routes.root.pattern.path))}
                  onClickLogOut={handleLogout}
                  user={user}
                  selectedCustomer={selectedCustomer}
                />
              ),
              type: 'Component',
            },
          ]
          : []),
      ] as ITopBarProps['content']}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  const user = state.entities?.user.user;
  const { selectedCustomer } = getCustomerState(state);
  return {
    user,
    selectedCustomer,
  };
};

const mapDispatchToProps = {
  getUserInfo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = connector(TopBar);

export { Container as TopBar };
